/* eslint-disable no-param-reassign,no-cond-assign,no-undef,no-nested-ternary */
import _ from 'lodash';
import { easeOutQuint } from 'js-easing-functions';

export function isTouch() {
  return typeof window !== 'undefined' && 'ontouchstart' in window;
}

export function hasClass(el, c) {
  if (!el.className) return false;
  const cls = el.className.split(' ');
  return _.some(cls, i => i === c);
}

export function addClass(el, c) {
  const add = e => {
    if (hasClass(e, c)) return;
    const cls = el.className ? el.className.split(' ') : [];
    cls.push(c);
    e.className = _.trim(cls.join(' '));
  };

  if (typeof el === 'string') {
    _.forEach(document.querySelectorAll(el), add);
  } else {
    add(el);
  }
}

export function removeClass(el, c) {
  const remove = e => {
    if (!el.className) return;
    const cls = el.className.split(' ');
    _.remove(cls, i => i === c);
    e.className = _.trim(cls.join(' '));
  };

  if (typeof el === 'string') {
    _.forEach(document.querySelectorAll(el), remove);
  } else {
    remove(el);
  }
}

export function toggleClass(el, c) {
  const toggle = e => {
    if (hasClass(e, c)) removeClass(e, c);
    else addClass(e, c);
  };

  if (typeof el === 'string') {
    _.forEach(document.querySelectorAll(el), toggle);
  } else {
    toggle(el);
  }
}

let scrollBody;

export function getScrollBody() {
  if (scrollBody) return scrollBody;
  if (document.documentElement.scrollTop > 0) {
    scrollBody = document.documentElement;
  } else if (document.body.scrollTop > 0) {
    scrollBody = document.body;
  }
  return scrollBody || document.body;
}

export function getOffsetTop(el) {
  let t1, t0;
  if (!el) return -1;
  t0 = el;
  t1 = el.offsetTop;
  while (t0 !== t0.offsetParent && (t0 = t0.offsetParent) !== null && t0 && t0.className !== 'app-scroll-body') {
    t1 += t0.offsetTop;
  }
  return t1;
}
export function getOffsetLeft(el) {
  let t1, t0;
  if (!el) return -1;
  t0 = el;
  t1 = el.offsetLeft;
  while (t0 !== t0.offsetParent && (t0 = t0.offsetParent) !== null && t0 && t0.className !== 'app-scroll-body') {
    t1 += t0.offsetLeft;
  }
  return t1;
}

export function getSectionTop(el) {
  let t1;
  let t0;
  let t2 = 0;
  let b;
  if (!el) return -1;
  t0 = el;
  t1 = el.offsetTop;
  while (t0 !== t0.offsetParent && (t0 = t0.offsetParent) !== null && t0.className !== 'app-scroll-body' && t0) {
    if (t0.tagName === 'SECTION') b = true;
    if (b) t2 += t0.offsetTop;
    t1 += t0.offsetTop;
  }
  return [t1, t2];
}

export function screenBottomCheck(items) {
  const lastScroll = getScrollBody().scrollTop;
  let i;
  for (i = 0; i < items.length; i += 1) {
    if (lastScroll + window.innerHeight * 0.7 > getOffsetTop(items[i])) {
      removeClass(items[i], 'below-screen');
    } else {
      addClass(items[i], 'below-screen');
    }
  }
}

export function pongCheck(items) {
  const lastScroll = getScrollBody().scrollTop;
  let i;
  for (i = 0; i < items.length; i += 1) {
    if (lastScroll + window.innerHeight > getOffsetTop(items[i]) + items[i].offsetHeight * 0.5) {
      addClass(items[i], 'pong');
    } else {
      removeClass(items[i], 'pong');
    }
  }
}

export function startSeq(item) {
  let id = -1;
  id = item.getAttribute('data-seq-id');
  if (id) return;

  const interval = item.getAttribute('data-seq-int') || 24;
  const len = +item.getAttribute('data-seq-len');
  const tpl = item.getAttribute('data-seq-tpl');
  let i = 0;

  id = setInterval(() => {
    item.src = tpl.replace('{num}', i);
    if (i === len) {
      clearInterval(id);
    }
    i += 1;
  }, interval);

  item.setAttribute('data-seq-id', id);
}

export function resetSeq(item) {
  const id = item.getAttribute('data-seq-id');
  const tpl = item.getAttribute('data-seq-tpl');
  if (id) clearInterval(+id);
  item.src = tpl.replace('{num}', 0);
  item.removeAttribute('data-seq-id');
}

export function seqCheck(items) {
  const lastScroll = getScrollBody().scrollTop();
  let i;
  for (i = 0; i < items.length; i += 1) {
    if (lastScroll + window.innerHeight * 0.7 > getOffsetTop(items[i])) {
      startSeq(items[i]);
    } else {
      resetSeq(items[i]);
    }
  }
}

export function scrollSync(items) {
  const lastScroll = getScrollBody().scrollTop();
  let i;
  const footerHeight = document.querySelector('div[footer]').offsetHeight * 2 - 50;
  for (i = 0; i < items.length; i += 1) {
    const v = getOffsetTop(items[i]) - (lastScroll + window.innerHeight - footerHeight);

    if (v < 0) {
      if (items[i].tagName.toUpperCase() === 'S') {
        items[i].style.marginTop = '0';
      } else {
        items[i].style.top = '0';
      }
      items[i].style.opacity = '1';
    } else {
      let st = v * 0.3;
      st = st > 300 ? 300 : st;
      if (items[i].tagName.toUpperCase() === 'S') {
        items[i].style.marginTop = `${st}px`;
      } else {
        items[i].style.top = `${st}px`;
      }
      items[i].style.opacity = Math.max(0.1, 1 - v / 200);
    }
  }
}

export function commaDecimal(num) {
  if (Number.isNaN(num)) return '';
  return num.toLocaleString().replace(/\.0+$/, '');
}

export function contParse(org) {
  if (!org) return '';
  return org
    .replace(/`\$([^`]+)`/g, '<img src="/api/files/$1">')
    .replace(/`\(([^)]+)\)(\+)?([^`]+)?`/g, (match, url, blank, cont) => `<a href="${url}" ${blank ? 'target="_blank"' : ''}>${cont || url}</a>`)
    .replace(
      /`(@)?(_)?(\*\[([^\]]+)])?([^`]+)`/g,
      (match, strong, underline, colorBlock, color, cont) =>
        `<span class="${strong ? 'bold' : ''} ${underline ? 'underline' : ''}" ${
          color ? `style="color:${color.split(',')[0]};background:${color.split(',').length > 1 ? color.split(',')[1] : 'none'}"` : ''
        }>${cont}</span>`
    )
    .replace(/\^(\d+)/g, (match, num) => _.reduce(num.split(''), (sum, n) => `${sum}&#${8320 + n * 1};`, ''))
    .replace(/\n/g, '<br>')
    .replace(/(\s{2,})/g, (match, space) => space.replace(/\s/g, '&nbsp;'));
}

export function formatBytes(a, b) {
  if (a === 0) return '0 Bytes';
  const c = 1024;
  const d = b || 2;
  const e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const f = Math.floor(Math.log(a) / Math.log(c));
  return `${parseFloat((a / c ** f).toFixed(d))} ${e[f]}`;
}

export function depthAssign(obj, path, value) {
  const arr = path.split('.');
  let stack = obj;
  let key = arr[0];
  for (let i = 0; i < arr.length; i += 1) {
    key = arr[i];
    if (i === arr.length - 1) stack[key] = value;
    else stack = stack[key];
  }
}

export function readNumber(value) {
  let n = parseFloat(value);
  if (Number.isNaN(n)) return '';
  n = Math.floor(n);
  if (n === 0) return '영';
  const phonemic = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
  const unit = ['', '', '십', '백', '천', '만', '십만', '백만', '천만', '억', '십억', '백억', '천억', '조', '십조', '백조'];

  let ret = '';
  let p;
  const part = [];
  for (let x = 0; x < String(n).length; x += 1) part[x] = String(n).substring(x, x + 1);
  for (let i = 0, cnt = String(n).length; cnt > 0; cnt -= 1, i += 1) {
    p = phonemic[part[i]];
    p += p ? (cnt > 4 && phonemic[part[i + 1]] ? unit[cnt].substring(0, 1) : unit[cnt]) : '';
    ret += p;
  }
  return ret;
}

export function fixedRound(value, places) {
  const multiplier = 10 ** places;
  return Math.round(value * multiplier) / multiplier;
}

export function setCookie(name, value) {
  const expire = new Date();
  expire.setFullYear(expire.getFullYear() + 1);
  document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; EXPIRES=' + expire.toGMTString();
}

export function getCookie(name) {
  let value = null;
  if (document.cookie) {
    const array = document.cookie.split(name + '=');
    if (array.length >= 2) {
      const arraySub = array[1].split(';');
      value = decodeURIComponent(arraySub[0]);
    }
  }
  return value;
}

export const sizeNames = ['sm', 'md', 'lg', 'xl'];

export function animate(start, end, duration, step) {
  let t = 0;
  const id = setInterval(() => {
    try {
      step(easeOutQuint(t, start, end, duration));
    } catch (e) {
      clearInterval(id);
    }
    if (t >= duration) clearInterval(id);
    t += 1;
  }, 16);
  return id;
}

export function numberAnimate(e) {
  e.na = true;
  if (e.innerText % 1 === 0) {
    animate(e.ns, e.ne, 60, (v) => (e.innerText = Math.ceil(v)));
  } else {
    animate(e.ns, e.ne, 60, (v) => (e.innerText = Math.round(v * 100) / 100));
  }
}

/*
10  30  60   90
100 200 300 400
 */

const $s = '$s';
const $e = '$e';

const getRatioIdx = (p, r) => {
  let i = p.length;
  if (p[i - 1] <= r) return $e;
  if (p[0] >= r) return $s;
  while (i--) if (p[i] >= r && p[i - 1] < r) return i - 1;
};

const getInterpolate = (p, i, r) => {
  return (r - p[i]) / (p[i + 1] - p[i]);
};

const applyInterpolate = (v, i, x) => {
  return +v[i] + (v[i + 1] - v[i]) * x;
};

const applyRatioElement = (el, r) => {
  let t0;
  if (!el.p) {
    t0 = el.getAttribute('data-p');
    if (!t0) return;
    el.p = t0.split(',');
    if ((t0 = el.getAttribute('data-a'))) el.a = t0.split(',');
    if ((t0 = el.getAttribute('data-y'))) el._y = t0.split(',');
    if ((t0 = el.getAttribute('data-x'))) el._x = t0.split(',');
    if ((t0 = el.getAttribute('data-py'))) el.py = t0.split(',');
    if ((t0 = el.getAttribute('data-px'))) el.px = t0.split(',');
    if ((t0 = el.getAttribute('data-h'))) el.h = t0.split(',');
    if ((t0 = el.getAttribute('data-ph'))) el.ph = t0.split(',');
  }
  const i = getRatioIdx(el.p, r);
  const l = el.p.length - 1;
  if (i === $s) {
    if (el.a) el.style.opacity = el.a[0];
    if (el._y) el.style.transform = `translateY(${el._y[0]}px)`;
    if (el._x) el.style.transform = `translateX(${el._x[0]}px)`;
    if (el.py) el.style.transform = `translateY(${el.py[0]}%)`;
    if (el.px) el.style.transform = `translateX(${el.px[0]}%)`;
    if (el.h) el.style.height = `${el.h[0]}px`;
    if (el.ph) el.style.height = `${el.ph[0]}%`;
  } else if (i === $e) {
    if (el.a) el.style.opacity = el.a[l];
    if (el._y) el.style.transform = `translateY(${el._y[l]}px)`;
    if (el._x) el.style.transform = `translateX(${el._x[l]}px)`;
    if (el.py) el.style.transform = `translateY(${el.py[l]}%)`;
    if (el.px) el.style.transform = `translateX(${el.px[l]}%)`;
    if (el.h) el.style.height = `${el.h[l]}px`;
    if (el.ph) el.style.height = `${el.ph[l]}%`;
  } else {
    const x = getInterpolate(el.p, i, r);
    if (el.a) el.style.opacity = applyInterpolate(el.a, i, x);
    if (el._y) el.style.transform = `translateY(${applyInterpolate(el._y, i, x)}px)`;
    if (el._x) el.style.transform = `translateX(${applyInterpolate(el._x, i, x)}px)`;
    if (el.py) el.style.transform = `translateY(${applyInterpolate(el.py, i, x)}%)`;
    if (el.px) el.style.transform = `translateX(${applyInterpolate(el.px, i, x)}%)`;
    if (el.h) el.style.height = `${applyInterpolate(el.h, i, x)}px`;
    if (el.ph) el.style.height = `${applyInterpolate(el.ph, i, x)}%`;
  }
};

export function applyRatio(list, ratio) {
  if (!list || list.length === 0) return;
  const r = ratio < 0 ? 0 : ratio > 1 ? 1 : ratio;
  for (let i = 0; i < list.length; ++i) {
    applyRatioElement(list[i], r);
  }
}
